import { render, staticRenderFns } from "./loaddetail.vue?vue&type=template&id=72102833&scoped=true"
import script from "./loaddetail.vue?vue&type=script&lang=js"
export * from "./loaddetail.vue?vue&type=script&lang=js"
import style0 from "./loaddetail.vue?vue&type=style&index=0&id=72102833&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72102833",
  null
  
)

export default component.exports